<template>
    <div>
        <b-card-body class="d-none d-md-block">
            <b-container>
                <survey>
                    <survey-row
                        v-for="(section, i1) in sections"
                        :key="i1" :title="section.titre"
                        :header="isFirstSection(i1) ? 'Points' : null">
                        <survey-answer
                            v-for="(answer, i2) in section.questions" :key="i2"
                            :answer="answer.titre">
                            <survey-response
                                v-for="(response, i3) in fillResponses(answer.echelle)"
                                :key="i3"
                                :response="response"
                                :radio-name="i2"
                                :radio-value="parseInt(i3)"
                                v-model="form[i2]"
                                :disabled="!canReply(i2) || lockedQuestionIds.includes(i2)"
                                @input="isDone()"
                            />
                        </survey-answer>
                    </survey-row>
                </survey>
            </b-container>
        </b-card-body>

        <!-- Body: Mobile -->
        <b-card-body class="d-block d-md-none">
            <section
                v-for="(section, i1) in sections"
                :key="i1">
                <div class="bg-primary p-1 text-white text-uppercase text-center mb-3">
                    <strong>{{ section.titre }}</strong>
                </div>
                <ol>
                    <li
                        v-for="(answer, i2) in section.questions"
                        :key="i2"
                        class="mb-3">
                        <div class="mb-2" :class="{ 'text-muted': !canReply(i2) }">{{ answer.titre }}</div>
                        <b-form-select
                            v-model="form[i2]"
                            :options="transform(answer.echelle)"
                            :disabled="!canReply(i2) || lockedQuestionIds.includes(i2)"
                            @input="isDone()"
                        />
                    </li>
                </ol>
            </section>
        </b-card-body>
    </div>
</template>
<script>
    import Survey from "../Survey";
    import SurveyRow from "../SurveyRow";
    import SurveyAnswer from "../SurveyAnswer";
    import SurveyResponse from "../SurveyResponse";

    export default {
        name: 'evaluation-ricci-gagnon',
        components: {
            SurveyResponse, 
            SurveyAnswer, 
            SurveyRow, 
            Survey
        },
        async mounted() {
            await this.$store.dispatch('base/evaluation/ricci/answers')
        },
        data: () => ({
            form: {},
            lockedQuestionIds: []
        }),
        computed: {
            userId() {
                return parseInt(this.$route.params.id)
            },
            sections() {
                return this.$store.state.base.evaluation.ricci.answers
            },
            answerIds() {
                const answerIds = Object.values(this.sections).map(s => Object.keys(s.questions))
                const flattenedIds = [].concat.apply([], answerIds)
                return flattenedIds
            },
            percentage() {
                return Math.round((Object.values(this.form).length / this.answerIds.length) * 100)
            },
            completed() {
                return this.answerIds.length === Object.values(this.form).length
            }
        },
        watch: {
            form: {
                handler: function(values) {
                    const regularActivity = parseInt(this.form['pratique_réguliere_activite_physique'])
                    this.lockedQuestionIds = regularActivity === 1
                        ? [ 'perception_effort', 'minutes_consacre_moyenne_chaque_seance', 'frequence_pratique_activite' ]
                        : []
                    
                    if (regularActivity !== 1) return
                    for (const lockedQuestionId of this.lockedQuestionIds)
                        this.$set(this.form, lockedQuestionId, 0)
                },
                deep: true
            }
        },
        methods: {
            isFirstSection(sectionKey) {
                const keys = Object.keys(this.sections)
                return keys.indexOf(sectionKey) === 0
            },
            canReply(answerKey) {
                const answerIndex = this.answerIds.indexOf(answerKey)
                const preAnswers = this.answerIds.slice(0, answerIndex)
                return preAnswers.every(a => this.form[a] !== undefined)
            },
            fillResponses(responses) {
                const _responses = Object.assign({}, responses)
                let i = 1
                for (i; i <= 5; i++)
                    if (_responses[i] === undefined)
                        _responses[i] = null
                return _responses
            },
            transform(responses) {
                return Object.keys(responses).map(value => ({value, text: responses[value]}))
            },
            isDone() {
                if (this.percentage === 100)
                    this.$emit('change', this.form)
            }
        }
    }
</script>
